import {Injectable} from '@angular/core';
import {LabelExpressionUtilityService} from '../label-expression-utility-service';
import {LabelExpressionBuildService} from './label-expression-build.service';
import {labelProperties, Attributes, SubTypeMap} from '../../../../common/models/label-expression.model';

@Injectable({
    providedIn: 'root'
})
export class InterestLabelExpressionBuilderService {
    title = 'InterestLabelExpressionBuilder';
    subTypeMap: SubTypeMap = [];

    constructor(
        private labelExpressionBuildService: LabelExpressionBuildService,
        private labelExpressionUtilityService: LabelExpressionUtilityService
    ) {
        this.init();
    }

    private init() {
        this.subTypeMap[1] = {function: this.buildInterestAnnotation.bind(this)};
        this.subTypeMap[2] = {function: this.buildInterestAnnotation.bind(this)};
        this.subTypeMap[24] = {function: this.buildInterestAnnotation.bind(this)};
    }

    build(attributes: Attributes) {
        return this.labelExpressionBuildService.build(this.title, this.subTypeMap, attributes);
    }

    buildInterestAnnotation(attributes: Attributes) {
        let attribute1 = '';
        let attribute2 = '';
        let labels = [];
        let labelProperties = {} as labelProperties;
        let fontColour = attributes.featuresubtype === 24 ? 'red' : undefined;
        let labelExpression = '';
        let value = '';

        if (attributes.attribute1) {
            value = '(' + this.labelExpressionUtilityService.encodeSpecialCharacters(attributes.attribute1) + ')';
            attribute1 = this.labelExpressionUtilityService.formatLabel(value, 10, true) + '\n';
            let style = this.labelExpressionUtilityService.getLabelProperties('10em', 'normal', 'middle', value);

            if (fontColour) {
                style.style['fill'] = fontColour;
            }
            labels.push(style);
        }

        if (attributes.attribute2 && attributes.attribute2 !== 'Remaining') {
            value = '' + 'Portion ' + this.labelExpressionUtilityService.encodeSpecialCharacters(attributes.attribute2) + '';
            attribute2 = this.labelExpressionUtilityService.formatLabel(value, 10, true);
            let style = this.labelExpressionUtilityService.getLabelProperties('10em', 'normal', 'middle', value);

            if (fontColour) {
                style.style['fill'] = fontColour;
            }
            labels.push(style);
        }

        labelExpression = (attribute1 + attribute2).replace(new RegExp('\n$'), '');
        if (labelExpression !== '') {
            labelProperties.labels = labels;
            labelProperties.labelExpression = labelExpression;
            return labelProperties;
        } else {
            return null;
        }
    }
}
